import {
  SERVICE_ORDERS_RECEIVE,
  SERVICE_ORDERS_ROW_QUANTITY_UPDATED,
  SERVICE_ORDERS_SET_LOADING,
  SERVICE_ORDERS_IS_PROCESSING,
  SERVICE_ORDERS_ERROR,
  SERVICE_ORDERS_CLEAR_ERROR,
  CHECKOUT_SET_ORDER_NOTES
} from "../Actions/ServiceOrders.action";

export const serviceOrders = (state = {}, action) => {
  switch (action.type) {
    case SERVICE_ORDERS_ROW_QUANTITY_UPDATED: {
      let serviceOrders = state.items;
      const serviceOrderIndex = serviceOrders.findIndex(
        (serviceOrder) => serviceOrder.id === action.payload.serviceOrderId
      );
      const rowIndex = serviceOrders[serviceOrderIndex].orderRows.findIndex(
        (row) => row.rowSystemId === action.payload.orderRowId
      );

      const rowItem = serviceOrders[serviceOrderIndex].orderRows[rowIndex];
      const quantity = Math.max(action.payload.quantity, 0);

      rowItem.quantity = quantity;
      rowItem.totalPrice = (rowItem.quantity * rowItem.itemPrice).toLocaleString("sv-SE", { style: 'currency', currency: 'SEK', minimumFractionDigits: 2, maximumFractionDigits: 2 })

      return {
         ...state,
         items: serviceOrders,
       };
    }
    case SERVICE_ORDERS_SET_LOADING: {
      const loadingOrderIndex = state.items.findIndex(
        (serviceOrder) => serviceOrder.id === action.payload.orderId
      );
      let serviceOrders = state.items;
      serviceOrders[loadingOrderIndex].isLoading = true;
      return {
        ...state,
        items: serviceOrders,
      };
    }
    case SERVICE_ORDERS_IS_PROCESSING: {
      return {
        ...state,
        isProcessing: action.payload.isProcessing
      };
    }
    case SERVICE_ORDERS_RECEIVE: {
      var orderIndex = state.items.findIndex(
        (serviceOrder) => serviceOrder.id === action.payload.id
      );
      let serviceOrders = [...state.items];
      serviceOrders[orderIndex] = action.payload;
      serviceOrders[orderIndex].isLoading = false;

      return {
        ...state,
        items: [...serviceOrders],
      };
    }
    case SERVICE_ORDERS_ERROR: {
      var orderIndex = state.items.findIndex(
        (serviceOrder) => serviceOrder.id === action.payload.id
      );
      let serviceOrders = [...state.items];
      serviceOrders[orderIndex].isLoading = false;

      return {
        ...state,
        items: [...serviceOrders],
        lastError: action.payload.error,
        lastErrorHandled: false,
      };
    }
    case SERVICE_ORDERS_CLEAR_ERROR: {
      return {
        ...state,
        lastErrorHandled: true,
      };
    }
    case CHECKOUT_SET_ORDER_NOTES:
        return {
            ...state,
            extraFields: action.payload.extraFields
        }

    default:
      return state;
  }
};
